// extracted by mini-css-extract-plugin
export default {"searchField":"styles_searchField__JDo2O","searchIcon":"styles_searchIcon__nvb2r"};